import React, {Component} from 'react';
import Aux from 'react-aux';
import Layout from "./layout/Layout";
import Home from "./pages/Home/Home";
import {Route} from 'react-router-dom';
import Drugs from "./pages/Drugs/Drugs";
import Statistics from "./pages/ATC-Statistics/ATCStatistics";
import DrugDetails from "./pages/DrugDetails/DrugDetails";
import CountryStatistics from "./pages/CountryStatistics/CountryStatistics";
import Companies from "./pages/Companies/Companies";
import CompanyStatistics from "./pages/CompanyStatistics/CompanyStatistics";
import CompanyRecentlyApproved from "./pages/CompanyRecentlyApproved/CompanyRecentlyApproved";
import CompareCountries from "./pages/CompareCountries/CompareCountries";
import Countries from "./pages/Countries/countries";
import {AboutComponent} from "./pages/About/about";
import '../public/inspinia/js/jquery-3.1.1.min'
import '../public/inspinia/js/popper.min'
import '../public/inspinia/js/bootstrap'

// import '../public/inspinia/js/inspinia'

class App extends Component {


    render() {
        return (
            <Aux>
                <Layout>
                    <Route path="/statistics" exact component={Statistics}/>
                    <Route path="/companies" exact component={Companies}/>
                    <Route path="/countries" exact component={Countries} />
                    <Route path="/companies/details" exact component={CompanyStatistics}/>
                    <Route path="/companies/details/recently-approved" exact component={CompanyRecentlyApproved}/>
                    <Route path="/drugs" exact component={Drugs}/>
                    <Route path="/drugs/:id" exact component={DrugDetails}/>
                    <Route path="/country/compare" exact component={CompareCountries}/>
                    <Route path="/countries/:countryCode" exact component={CountryStatistics}/>
                    <Route path="/about-us" exact component={AboutComponent}/>
                    <Route path="/" exact component={Home}/>
                </Layout>
            </Aux>
        );
    }
}

export default App;
